import { Region } from './constants';

/**
 * Detect region from hostname (for standalone builders)
 * - In local dev (localhost), uses AWS_REGION env var
 * - In production, checks if hostname contains '.eu.'
 */
export const getRegionFromHostname = (): Region => {
  const { hostname } = window.location;

  if (hostname.includes('localhost')) {
    const localregion = import.meta.env.LOCAL_REGION;
    if (localregion) {
      return localregion.includes('EU') ? 'EU' : 'US';
    }
    return 'US';
  }

  // In production, detect from hostname (strict match with trailing dot)
  return hostname.includes('.eu.') ? 'EU' : 'US';
};
